
<div class="direct-call-detail" v-if="call">
  <div class="ui stackable grid">
    <div class="eight wide column">
      <div class="ui segment" style="height: 100%;">
        <div class="ui warning message">
          <div style="display: flex; align-items: center;">
            <i class="exclamation triangle large icon yellow" style="margin-right: 10px;"></i>
            <span>この文字起こしは AI による自動生成です。誤りが含まれる可能性があります。必ず原音声を確認のうえ、ご利用ください。</span>
          </div>
        </div>
        <template v-if="call.summary">
          <h3>要約</h3>
          <p class="ui message linebreak">{{ call.summary }}</p>
        </template>
        <h3>自動文字起こし</h3>
        <p>お名前：{{ call.transcribed_name }}</p>
        <p>通話内容 -</p>
        <p class="linebreak">{{ call.transcribed_text }}</p>
      </div>
    </div>
    <div class="eight wide column">
      <h3>ステータス</h3>
      <table class="ui definition keyValueTable table">
        <tr>
          <td>ステータス</td>
          <td>
            <div style="display: flex; flex-direction: column; gap: 12px;">
              <div>
                <span v-if="call.shop_status === 'visited'">実施済み</span>
                <template v-else>
                  <div class="ui message warning">
                    案件が実施された場合は、「実施済み」ステータスへ変更をお願いいたします。
                  </div>
                  <dropdown v-model="call.shop_status" @change="saveShopStatus">
                    <option value="initial">未対応</option>
                    <option value="active">対応中</option>
                    <option value="reserved">予約確定</option>
                    <option value="closed">クローズ</option>
                  </dropdown>
                </template>
              </div>
              <div>
                <button v-if="call.shop_status === 'initial' || call.shop_status === 'active' || call.shop_status === 'reserved'" class="ui tiny positive button" @click="openRegisterContractDialog()">実施済み</button>
                <button v-if="call.direct_call_contract && call.shop_status === 'visited'" class="ui tiny positive button" @click="openContractDialog()">成約金額を確認する</button>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div class="user-info">
        <h3>お客様情報</h3>
        <a @click="openEditDialog">
          <i class="edit icon"></i>お客様情報を編集
        </a>
      </div>
      <table class="ui definition keyValueTable table">
        <tr>
          <td>会社・団体名</td>
          <td>{{ call.company_name }}</td>
        </tr>
        <tr>
          <td>お名前（カナ）</td>
          <td>{{ call.name_kana}}</td>
        </tr>
        <tr>
          <td>希望日時</td>
          <td>{{ call.event_date | formatDate }} {{ call.event_time }}</td>
        </tr>
        <tr>
          <td>希望人数</td>
          <td><template v-if="call.people">{{ call.people }}人</template></td>
        </tr>
        <tr>
          <td>メモ</td>
          <td>
            <div class="linebreak">{{ call.memo }}</div>
          </td>
        </tr>
      </table>

      <h3>通話データ</h3>
      <table class="ui definition keyValueTable table">
        <tr>
          <td>名前</td>
          <td>
            <a v-if="call.name_recording_url" :href="call.name_recording_url" target="_blank">確認する</a>
          </td>
        </tr>
        <tr>
          <td>日時/人数</td>
          <td>
            <a v-if="call.details_recording_url" :href="call.details_recording_url" target="_blank">確認する</a>
          </td>
        </tr>
        <tr>
          <td>通話</td>
          <td>
            <a v-if="call.recording_url" :href="call.recording_url" target="_blank">確認する</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div id="memo-edit-dialog" class="ui small modal">
    <div class="header">
      <h3>お客様情報編集</h3>
    </div>
    <div class="scrolling content">
      <div class="ui message">
        【自動文字起こし】<br>
        [お名前] {{ call.transcribed_name }}<br>
      </div>
      <form class="ui form" :class="{'warning': editForm.hasErrors()}">
        <div class="field">
          <label>会社・団体名</label>
          <input v-model="editForm.model.company_name" type="text" placeholder="会社・団体名">
          <validation-message :form="editForm" field="company_name"></validation-message>
        </div>
        <div class="field">
          <label>お名前(カナ)</label>
          <input v-model="editForm.model.name_kana" type="text" placeholder="お名前">
          <validation-message :form="editForm" field="name_kana"></validation-message>
        </div>
        <div class="field">
          <label>希望日</label>
          <datepick v-model="editForm.model.event_date" placeholder="希望日時"></datepick>
          <validation-message :form="editForm" field="event_date"></validation-message>
        </div>
        <div class="field">
          <label>希望時間</label>
          <dropdown v-model="editForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" placeholder="希望時間">
            <option v-for="each in consts.MARUNAGE_EVENT_TIME" :key="each.value" :value="each.value">{{ each.label }}</option>
          </dropdown>
          <validation-message :form="editForm" field="event_time"></validation-message>
        </div>
        <div class="field">
          <label>希望人数</label>
          <input v-model="editForm.model.people" type="number" placeholder="希望人数">
          <validation-message :form="editForm" field="people"></validation-message>
        </div>
        <div class="field">
          <label>メモ</label>
          <textarea v-model="editForm.model.memo" />
          <validation-message :form="editForm" field="memo"></validation-message>
        </div>
      </form>
    </div>
    <div class="actions">
      <div class="ui button" @click="closeEditDialog">閉じる</div>
      <div class="ui green button" :class="{'loading disabled': editForm.waiting}" @click="save">保存する</div>
    </div>
  </div>

  <div id="register-contract-dialog" class="ui small modal">
    <i class="close icon"></i>
    <div class="header">来店確認・成約金額登録</div>
    <div class="scrolling content" style="min-height: 400px;">
      <div class="ui negative message">※ご利用金額に応じて、お客様へギフト券をプレゼントしています。<br>正確にご入力をお願いいたします。</div>
      <form class="ui form contractForm" :class="{warning: registerContractForm.hasErrors()}">
        <div class="contractForm__contentTitleContainer">
          <h3 class="contractForm__contentTitle">宴会の実施内容</h3>
        </div>
        <div class="two fields" style="flex-wrap: nowrap;">
          <div class="required field">
            <label>実施日</label>
            <datepick v-model="registerContractForm.model.event_date" :placeholder="'実施日'"></datepick>
            <validation-message :form="registerContractForm" :field="'event_date'"></validation-message>
          </div>
          <div class="required field">
            <label>実施時間</label>
            <dropdown v-model="registerContractForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'実施時間'"></dropdown>
            <validation-message :form="registerContractForm" :field="'event_time'"></validation-message>
          </div>
        </div>
        <div class="required field">
          <label>お名前(カナ)</label>
          <input type="text" v-model="registerContractForm.model.name_kana" placeholder="お名前(カナ)">
          <validation-message :form="registerContractForm" :field="'name_kana'"></validation-message>
        </div>
        <div class="two fields" style="flex-wrap: nowrap;">
          <div class="required field">
            <label>コース料金(お一人様)</label>
            <input type="number" v-model="registerContractForm.model.detail_price" :placeholder="'コース料金(お一人様)'">
            <validation-message :form="registerContractForm" :field="'detail_price'"></validation-message>
          </div>
          <div class="required field">
            <label>実施人数</label>
            <input type="number" v-model="registerContractForm.model.detail_people" :placeholder="'実施人数'">
            <validation-message :form="registerContractForm" :field="'detail_people'"></validation-message>
          </div>
        </div>
        <div class="required eight wide field">
          <label>コース料金総額(税込)</label>
          <input type="text" :value="totalCoursePrice.toLocaleString()" :placeholder="'コース料金総額(税込)'" disabled>
        </div>
        <div class="contractForm__contentTitleContainer">
          <h3 class="contractForm__contentTitle">その他のご利用金額</h3>
          <p>延長料金、会議利用料、備品などをご入力ください。</p>
        </div>
        <div class="fields" v-for="(item, index) in registerContractForm.model.optional_items" :key="index">
          <div class="field seven wide">
            <label :class="{'contractForm__optionalInputLabel': index !== 0}">項目</label>
            <input class="contractForm__OptionalInputField" type="text" v-model="item.name" :placeholder="'マイク利用貸与料金'">
              <validation-message :form="registerContractForm" :field="'optional_items'" :subField="'name'" :index="index"></validation-message>
          </div>
          <div class="field seven wide">
            <label :class="{'contractForm__optionalInputLabel': index !== 0}">金額</label>
            <input class="contractForm__OptionalInputField" type="number" v-model="item.price" :placeholder="'10,000'">
            <validation-message :form="registerContractForm" :field="'optional_items'" :subField="'price'" :index="index"></validation-message>
          </div>
          <div v-if="index !== 0 && (registerContractForm.model.optional_items.length - 1) === index"
               class="field contractForm__optionalButtonContainer pcOnly">
            <button type="button" class="ui tiny red button icon" @click="removeOtherItem(index)">
              <i class="trash alternate outline icon"></i>
            </button>
          </div>
        </div>
        <div class="field fourteen wide contractForm__optionalButtonContainer pcOnly">
          <button type="button" class="ui button icon" @click="addOtherItem">
            <i class="clickable plus icon"></i> 追加する
          </button>
        </div>
        <div class="field contractForm__optionalButtonContainerMobile spOnly">
          <button type="button" class="ui tiny button icon" @click="addOtherItem">
            <i class="clickable plus icon"></i> 追加する
          </button>
          <button v-if="registerContractForm.model.optional_items.length > 1" type="button" class="ui tiny red button icon" @click="removeOtherItem(index)">
            <i class="trash alternate outline icon"></i>
          </button>
        </div>
        <div class="two fields">
          <div class="required field eight wide">
            <label>お支払い総額計(税込)</label>
            <input type="text" :value="totalPrice.toLocaleString()" :placeholder="'お支払い総額計(税込)'" disabled>
          </div>
        </div>
        <div class="contractForm__contentTitleContainer">
          <h3 class="contractForm__contentTitle">レシート添付</h3>
        </div>
        <div class="fields">
          <div class="required field sixteen wide">
            <p>レシート、もしくは金額の内容がわかるものを添付ください。</p>
            <s3 v-model="registerContractForm.model.receipt_image" :accept="'image/*,application/pdf'"></s3>
            <validation-message :form="registerContractForm" :field="'receipt_image'"></validation-message>
            <p style="margin-top: 5px;">※JPEG、PNG、PDFのみ</p>
          </div>
        </div>
      </form>
      <div class="ui positive message">
        請求に関して不明点がある場合は、以下までご連絡ください。<br><br><br>
        【グルメプラスサポート（株式会社オールフィット）】<br>
        メールアドレス：info@gourmetplus.jp<br>
        電話番号：0422-24-9496
      </div>
    </div>
    <div class="actions">
      <div class="ui cancel button">閉じる</div>
      <div class="ui green button" :class="{'loading disabled': registerContractForm.waiting}" @click="registerContract">金額を登録する</div>
    </div>
  </div>

  <div id="contract-dialog" class="ui small modal">
    <i class="close icon"></i>
    <div class="header">来店確認・成約金額登録</div>
    <div class="scrolling content" style="min-height: 400px;">
      <form class="ui form contractForm" v-if="contract">
        <div class="contractForm__contentTitleContainer">
          <h3 class="contractForm__contentTitle">宴会の実施内容</h3>
        </div>
        <div class="two fields" style="flex-wrap: nowrap;">
          <div class="required field">
            <label>実施日</label>
            <p class="contractForm__viewContent">{{ contract.event_date }}</p>
          </div>
          <div class="required field">
            <label>開始時間</label>
            <p class="contractForm__viewContent">{{ contract.event_time }}</p>
          </div>
        </div>
        <div class="two fields" style="flex-wrap: nowrap;">
          <div class="required field">
            <label>コース料金(お一人様)</label>
            <p class="contractForm__viewContent">{{ contract.detail_price | formatCurrency }}</p>
          </div>
          <div class="required field">
            <label>実施人数</label>
            <p class="contractForm__viewContent">{{ contract.detail_people }}</p>
          </div>
        </div>
        <div class="required field">
          <label>コース料金総額(税込)</label>
          <p class="contractForm__viewContent">{{ contract.total_course_price | formatCurrency }}</p>
        </div>
        <div class="contractForm__contentTitleContainer">
          <h3 class="contractForm__contentTitle">その他のご利用金額</h3>
        </div>
        <div v-if="contract.optional_items.length === 0" class="fields">
          <div class="field seven wide contractForm__OptionalInputField">
            <label>項目</label>
          </div>
          <div class="field seven wide contractForm__OptionalInputField">
            <label>金額</label>
          </div>
        </div>
        <div class="fields" v-for="(item, index) in contract.optional_items" :key="index">
          <div class="field seven wide contractForm__OptionalInputField">
            <label>項目</label>
            <p class="contractForm__viewContent">{{ item.name }}</p>
          </div>
          <div class="field seven wide contractForm__OptionalInputField">
            <label>金額</label>
            <p class="contractForm__viewContent">{{ item.price | formatCurrency }}</p>
          </div>
        </div>
        <div class="required field sixteen wide" style="margin-top: 40px;">
          <label>お支払い総額計(税込)</label>
          <p class="contractForm__viewContent">{{ contract.total_price | formatCurrency }}</p>
        </div>
        <div class="contractForm__contentTitleContainer">
          <h3 class="contractForm__contentTitle">レシート</h3>
        </div>
        <div class="fields">
          <div class="field sixteen wide">
            <div class="receiptView">
              <p v-if="!contract.receipt_image" class="contractForm__viewContent">入力なし</p>
              <span v-else-if="contract.receipt_image.mime_type === 'application/pdf'" class="pdfIcon">
                <i class="fas fa-file-pdf"></i>
              </span>
              <img v-else-if="contract.receipt_image.urls.preview" :src="contract.receipt_image.urls.preview">
              <img v-else-if="contract.receipt_image.urls.small" :src="contract.receipt_image.urls.small">
              <span v-if="contract.receipt_image" class="filename" :title="contract.receipt_image.original_file_name">{{ contract.receipt_image.original_file_name }}</span>
              <button v-if="contract.receipt_image" class="ui mini negative button" type="button" @click="viewReceipt()">確認する</button>
            </div>
          </div>
        </div>
      </form>
      <div class="ui positive message">
        請求に関して不明点がある場合は、以下までご連絡ください。<br><br><br>
        【グルメプラスサポート（株式会社オールフィット）】<br>
        メールアドレス：info@gourmetplus.jp<br>
        電話番号：0422-24-9496
      </div>
    </div>
    <div class="actions">
      <div class="ui cancel button">閉じる</div>
    </div>
  </div>
</div>
